import { CSSProperties } from 'react';

interface IGiftIcon {
    color?: string;
    width?: string;
    height?: string;
    strokeWidth?: string;
    style?: CSSProperties,
}

const GiftIcon = (props: IGiftIcon) => {

    const color = props?.color || '#4DA612';
    const width = props?.width || '26';
    const height = props?.height || '27';
    const strokeWidth = props?.strokeWidth || '0.1';

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={ width }
            height={ height }
            style={ props.style }
            viewBox="0 0 26 27">
            <g fill={ color } fillRule="evenodd">
                <path stroke={ color } strokeWidth={ strokeWidth } d="M2.143 9.05v4.64c0 .233.189.422.422.422h.844v11.812c0 .233.189.422.422.422H21.55a.421.421 0 0 0 .421-.422V14.112h.844a.422.422 0 0 0 .422-.422V9.05a.422.422 0 0 0-.422-.423h-4.564a2.732 2.732 0 0 0 .767-1.898 2.745 2.745 0 0 0-2.742-2.742h-1.265c-.978 0-1.836.516-2.32 1.288a2.741 2.741 0 0 0-2.321-1.288H9.104a2.745 2.745 0 0 0-2.742 2.742c0 .736.293 1.405.768 1.898H2.565a.422.422 0 0 0-.421.422zm2.11 5.062h5.906v11.39H4.253v-11.39zm6.75-.422V9.47h3.375v16.031h-3.375V13.69zm10.125 11.812H15.22v-11.39h5.907v11.39zm1.265-12.234h-7.171V9.471h7.171v3.797zM15.01 4.831h1.266a1.9 1.9 0 0 1 1.898 1.898 1.9 1.9 0 0 1-1.898 1.898h-3.164V6.73a1.9 1.9 0 0 1 1.898-1.898zM7.206 6.729a1.9 1.9 0 0 1 1.898-1.898h1.266a1.9 1.9 0 0 1 1.898 1.898v1.898H9.104a1.9 1.9 0 0 1-1.898-1.898zM2.987 9.471h7.172v3.797H2.987V9.47z"/>
                <path d="M24.503.034h-.844v.843h-.844v.844h.844v.844h.844v-.844h.843V.877h-.843zm0 5.062h.843v.844h-.843zm-4.219-3.375h.844v.844h-.844zm3.375 4.219v-.844c-1.164 0-2.11.946-2.11 2.11h.844c0-.699.568-1.266 1.266-1.266zm-22.782 0h.844v-.844h.844v-.843h-.844v-.844H.877v.844H.034v.843h.843zM4.253.034h.843v.843h-.843zm2.953 2.109h.844C8.05.98 7.103.033 5.94.033v.845c.698 0 1.266.567 1.266 1.265zM12.268.034h.844v.843h-.844zM.034.034h.843v.843H.034z"/>
            </g>
        </svg>
    )
};

export default GiftIcon;